// extracted by mini-css-extract-plugin
export default {"icon":"ARX+p","iconWrapper":"Ifqyr"};